export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "batch.worker.3e30a510ab0f8b4943eb.worker.js");
}
